import { hashTagsService } from "motw_core/Services/HashTagsService";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { GetDreamRows } from "source/app/presentation/MainPanel/Dreams/HashTags/GetDreamRows";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export function HandleRemoveHashTagRequest(hashTag: string) {
    WithAnimatedProgressBarAsync(async () => {
        const dreams = GetDreamRows();

        await hashTagsService.RemoveHashTagAsync(
            dreams,
            hashTag,
            ClientDataProvider
        );

        Data.Load.Single.ByStateTarget<IDreamsState>("dreamsdata");
    });
}
